import _Promise from "@babel/runtime-corejs3/core-js/promise";
import { defineComponent, onMounted, ref, toRefs, nextTick } from "@vue/composition-api";
import DOMPurify from "dompurify";
import DefaultBodyLoader from "../modals/generic-modal-loaders/default-body-loader.vue";
export default defineComponent({
  name: "HtmlIframePreview",
  components: {
    DefaultBodyLoader
  },
  props: {
    id: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    breakContentWords: {
      type: Boolean,
      default: false
    }
  },
  setup(props, {
    emit
  }) {
    const {
      content
    } = toRefs(props);
    const {
      breakContentWords
    } = toRefs(props);
    const src = ref("");
    const iframeElement = ref();
    const loading = ref(false);
    const hasError = ref(false);
    const resizeIframe = () => {
      var _iframeElement$value, _iframeElement$value$;
      let offsetHeight = 0;
      const iframeNode = iframeElement.value;
      if (!iframeNode) return 0;
      offsetHeight = ((_iframeElement$value = iframeElement.value) == null ? void 0 : (_iframeElement$value$ = _iframeElement$value.contentWindow) == null ? void 0 : _iframeElement$value$.document.body.offsetHeight) || 0;
      iframeNode.style.height = offsetHeight + 15 + "px";
      return offsetHeight;
    };
    const loadEmailIntoHTML = async () => {
      return new _Promise((resolve, reject) => {
        window.requestAnimationFrame(() => {
          const htmlString = src.value;
          try {
            var _iframeElement$value2, _iframeElement$value3;
            const htmlNode = document.createElement("html");
            htmlNode.innerHTML = DOMPurify.sanitize(htmlString);
            htmlNode.querySelectorAll("base").forEach(meta => {
              meta.remove();
            });
            htmlNode.querySelectorAll("a").forEach(anchor => {
              anchor.target = "_blank";
            });
            const bodyNode = htmlNode.querySelector("body");
            bodyNode == null ? void 0 : bodyNode.style.setProperty("display", "inline-block");
            bodyNode == null ? void 0 : bodyNode.style.setProperty("width", "100%");
            if (breakContentWords.value) {
              bodyNode == null ? void 0 : bodyNode.style.setProperty("word-break", "break-word");
              bodyNode == null ? void 0 : bodyNode.style.setProperty("margin", "0");
            }
            const iframe = iframeElement.value;
            if (!iframe) return;
            const iframeDocument = (_iframeElement$value2 = iframeElement.value) == null ? void 0 : (_iframeElement$value3 = _iframeElement$value2.contentWindow) == null ? void 0 : _iframeElement$value3.document;
            iframeDocument == null ? void 0 : iframeDocument.open();
            iframeDocument == null ? void 0 : iframeDocument.write(htmlNode.innerHTML);
            iframeDocument == null ? void 0 : iframeDocument.close();
            resolve();
          } catch (e) {
            reject(e);
          }
        });
      });
    };
    const listenForDoubleClick = () => {
      var _iframeElement$value4, _iframeElement$value5;
      (_iframeElement$value4 = iframeElement.value) == null ? void 0 : (_iframeElement$value5 = _iframeElement$value4.contentWindow) == null ? void 0 : _iframeElement$value5.document.addEventListener("dblclick", event => emit("dblclick", event));
    };
    const onLoad = () => {
      loading.value = false;
      nextTick(() => {
        resizeIframe();
        listenForDoubleClick();
      });
    };
    onMounted(async () => {
      src.value = content.value;
      try {
        loading.value = true;
        loadEmailIntoHTML();
        hasError.value = false;
      } catch (error) {
        hasError.value = true;
      }
    });
    return {
      loading,
      hasError,
      src,
      onLoad,
      iframeElement
    };
  }
});